import React from 'react';
import {router } from 'umi';
import NavBar from '@/components/NavBar';
import styles from './index.less';
import imgsucc from '@/assets/imgs/pay_result_succ.png';
import { TLang } from '@/utils/lang';
const SuccPage = (props) => {
  const toHomePageHandle = () => {
    router.replace('/');
  };
  const toOrderDescHandle =() => {
    // sn
    const sn = props.location.query.sn;
    if(!sn){
      router.replace('/order');
    }else{
      // router.replace(`/order/status?orderSn=${sn}`);
      const origin = window.location.origin;
      window.df_sdk_common.location.replace(origin + `/newmovie/order/status?orderSn=${sn}`);
    }
  };
  return (
    <div>
      <NavBar isShowMenu showBack={false} showBottom showService text={TLang('支付结果', 'home', false, false, null)} initColor="#333" targetColor="#333" targetBgColor="#FFF" opacity={1} textStyles={{marginLeft:'1.5rem'}}/>

      <div className={styles.payWrapper}>
        <img src={imgsucc} alt={TLang('支付成功', 'home', false, false, null)}/>
        <p>{TLang('支付成功', 'home', false, false, null)}</p>
        <div className={styles.payBtns}>
          <div className={`${styles.btn}`} onClick={toHomePageHandle}>{TLang('返回首页', 'home', false, false, null)}</div>
          <div className={`${styles.btn} ${styles.orderBtn}`} onClick={toOrderDescHandle}>{TLang('查看订单', 'home', false, false, null)}</div>
        </div>
      </div>
    </div>
  );
};

export default SuccPage;
